import { Link } from 'react-router-dom';
import { useState, useCallback } from 'react';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '网红塌房', path: '/category/wanghong-tafang' },
    { label: '选秀黑幕', path: '/category/xuanxiu-heimu' },
    { label: '综艺翻车', path: '/category/zongyi-fanche' },
    { label: '直播爆料', path: '/category/zhibo-baoliao' },
  ],
  about: [
    { label: '关于我们', path: '/about' },
    { label: '联系方式', path: '/about#contact' },
    { label: '品牌故事', path: '/about#story' },
    { label: '用户口碑', path: '/about#reviews' },
    { label: '加入我们', path: '/about#join' },
  ],
  legal: [
    { label: '隐私政策', path: '/privacy' },
    { label: '用户协议', path: '/terms' },
    { label: '免责声明', path: '/disclaimer' },
  ],
};

const socialLinks = [
  { icon: 'ri-weibo-fill', label: '微博', href: '#' },
  { icon: 'ri-wechat-fill', label: '微信', href: '#' },
  { icon: 'ri-tiktok-fill', label: '抖音', href: '#' },
];

export default function Footer() {
  const [subStatus, setSubStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [subMsg, setSubMsg] = useState('');

  const handleSubscribe = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setSubStatus('success');
      setSubMsg('订阅成功！');
      form.reset();
      setTimeout(() => setSubStatus('idle'), 3000);
      return;
    }

    setSubStatus('idle');
    setSubMsg('');

    try {
      const body = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'website_alt') {
          body.append(key, value as string);
        }
      });

      const res = await fetch('https://readdy.ai/api/form/d96dqh7pg5pqhofcunsg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      const responseText = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* JSON parse failure, use raw responseText */ }

      if (res.ok && parsed?.code === 'OK') {
        setSubStatus('success');
        setSubMsg('订阅成功！感谢关注~');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        if (typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam')) {
          setSubStatus('success');
          setSubMsg('订阅成功！');
          form.reset();
        } else {
          setSubStatus('error');
          setSubMsg(typeof serverMsg === 'string' ? serverMsg : '订阅失败，请稍后重试');
        }
      }
    } catch {
      setSubStatus('error');
      setSubMsg('网络错误，请稍后重试');
    }

    setTimeout(() => setSubStatus('idle'), 4000);
  }, []);

  return (
    <footer className="px-4 md:px-6 pb-6 pt-2">
      <div className="mx-auto max-w-[1280px] rounded-2xl bg-foreground-900 px-6 md:px-12 py-12 md:py-16 relative overflow-hidden">
        {/* Background watermark */}
        <div className="absolute -bottom-8 right-0 text-[180px] font-heading font-black text-foreground-800/15 leading-none select-none pointer-events-none whitespace-nowrap">
          黑料
        </div>

        <div className="relative z-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-fill text-background-50 text-xl"></i>
              </div>
              <div>
                <span className="text-background-50 font-bold text-lg font-heading whitespace-nowrap">
                  每日大赛黑料
                </span>
                <span className="text-foreground-400 text-xs block leading-tight whitespace-nowrap">
                  一手爆料 · 吃瓜不停
                </span>
              </div>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed mb-6">
              每日大赛黑料网，汇集网红塌房现场一手爆料，黑料每日更新。
              我们致力于为吃瓜群众提供最新、最热、最全的娱乐八卦资讯。
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:bg-foreground-700 transition-colors cursor-pointer"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Navigation Column */}
          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4 font-heading">
              <a href="/" className="hover:text-primary-400 transition-colors">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About Column */}
          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4 font-heading">
              <a href="/about" className="hover:text-primary-400 transition-colors">关于</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter Column */}
          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4 font-heading">订阅爆料</h4>
            <p className="text-foreground-400 text-sm mb-4 leading-relaxed">
              第一时间获取最新黑料，不错过任何一个瓜。
            </p>
            <form
              id="subscribe"
              data-readdy-form=""
              onSubmit={handleSubscribe}
              className="flex flex-col sm:flex-row gap-2"
            >
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <input
                type="email"
                name="email"
                placeholder="输入你的邮箱"
                required
                className="flex-1 px-4 py-2.5 bg-foreground-800 border border-foreground-700 rounded-lg text-background-50 text-sm placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
              />
              <button
                type="submit"
                className="w-10 h-10 bg-primary-500 rounded-lg flex items-center justify-center flex-shrink-0 hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line text-background-50 text-lg"></i>
              </button>
            </form>
            {subStatus !== 'idle' && (
              <p className={`mt-3 text-xs ${subStatus === 'success' ? 'text-accent-400' : 'text-red-400'}`}>
                {subMsg}
              </p>
            )}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="relative z-10 mt-10 pt-6 border-t border-foreground-800/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 每日大赛黑料网. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            {footerLinks.legal.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors whitespace-nowrap"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}